import { formatTitle } from "~components/ContentMetadata";
import { Story } from "~types/types";
import { getGtmTrackingData } from "~utils/getGtmTrackingData";

declare const window: Window &
    typeof globalThis & {
        PARSELY: any;
        __bloomberg__: any;
    };

const ALLOWED_QUERY_PARAMETERS = [
    "sref",
    "mockResponse",
    "articlesRemaining",
    "showPaywall",
    "abbaPreview",
    "debugAds",
    "test",
    "srnd",
];

export const createQueryString = (query: string) => {
    const params = new URLSearchParams(query);

    [...params.keys()].forEach((key: string) => {
        if (!ALLOWED_QUERY_PARAMETERS.includes(key)) {
            params.delete(key);
        }
    });

    if ([...params].length > 0) {
        return `?${params.toString()}`;
    }

    return "";
};

export const updateUrl = (url: string, isTransportedStory: boolean) => {
    const pageUrl = url.split(".com")[1];
    const previousQueryParams = isTransportedStory
        ? createQueryString(location.search)
        : location.search;
    const newPath = `${pageUrl}${previousQueryParams}`;

    // TODO: Migrate to next/router
    // Tried to use next/router to change the window location, but ran into sparkle error
    if (window.history.replaceState) {
        window.history.replaceState({}, "", newPath);
    }
};

export const updateTitle = (title: string, locale: string) => {
    if (!document) {
        return;
    }

    document.title = formatTitle(title, locale);
};

export const gtmTrackPageView = (
    story: Story,
    previousUrl: string,
    transporter: boolean
) => {
    const baseTrackingData = getGtmTrackingData(story);
    const trackingData = {
        ...baseTrackingData,
        referrer: previousUrl,
        transporter: String(transporter),
    };

    window.dataLayer?.push(trackingData);

    // This is the event that triggers the GA - Pageview tag on transport
    if (transporter) {
        window.dataLayer?.push({ event: "Track Request - PV" });
    }
};

export const parselyTrackPageView = (referrer: string) => {
    if (window.PARSELY?.beacon) {
        window.PARSELY.beacon.trackPageView({
            url: window.location.href,
            urlref: referrer,
            js: 1,
        });
    }
};

export const recordPageView = (story: Story, isTransportedStory: boolean) => {
    const previousUrl = window.location.href;

    gtmTrackPageView(story, previousUrl, isTransportedStory);
    parselyTrackPageView(previousUrl);
};

export const updateUrlTitle = (story: Story, isTransportedStory: boolean) => {
    if (story.url) {
        updateUrl(story.url, isTransportedStory);
    }

    updateTitle(story.seoTitle, story.locale);
};
